import React from 'react';

interface HeaderActionsProps {
  onClose?: () => void;
  closeTitle?: string;
}

const HeaderActions: React.FC<HeaderActionsProps> = ({
  onClose,
  closeTitle = "Close"
}) => {
  return (
    <>
      <button
        type="button"
        onClick={onClose}
        className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-md transition-colors"
        title={closeTitle}
        disabled={!onClose}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </>
  );
};

export default HeaderActions;
